/* Response Time CSS */

import palette from '../../../../../../theme/index';

export default theme => ({
    root: {},
    sizeDivider:{
        height:"3px"
    },
    back:{
        backgroundColor:"rgb(27,27,27)"
    },
    gridItem:{
        paddingRight:"4px"
    },
    textField:{
        transform: "translate(0px, -7px) scale(1)",
        fontSize: "13px"
    },
    contentCircular:{
        textAlign:"center", 
        //backgroundColor:"black"
    },
    circular:{
        //color:"white"
    },
    uptime:{
        background:palette.colors.uptime.primary
    }

})